import { createFileRoute } from "@tanstack/react-router";
import { AppError } from "shared/components/global/AppError/AppError";

/** @public */
export const Route = createFileRoute("/_auth/messages")({
    errorComponent: AppError,
});
